module.exports = __webpack_public_path__ + "static/media/randomconcretesection.a5405918.svg";